import React, { useEffect, useState } from 'react'
import WSelect from '../../components/molecules/WSelect'
import { api } from '../../utils'
import { extractData } from '../../utils/index_tagging_tool'

const LanguageSelector = ({ language, setLanguage }) => {
  const [languages, setLanguages] = useState([]);

  useEffect(() => {
    // Fetch report details
    api.get(`/tagging-tool/languages/`)
      .then(extractData)
      .then((data) => setLanguages(data))
      .catch(console.error); // Added basic error handling

  }, []);

  return (
    <WSelect
       options={languages.map((l) => l.code)}
       value={language}
       setValue={setLanguage}
       defaultValue={'it'}
       placeholder={'Seleziona il codice lingua'}
    />
  )
}

export default LanguageSelector
